<!-- Accessibility Popup -->
<div *ngIf="popup === 'accessibility'" class="legal-overlay" (click)="closePopup()">
  <div class="legal-dialog" role="dialog" aria-modal="true" aria-labelledby="legal-accessibility-title" (click)="$event.stopPropagation()">
    <app-modal-header title="Accessibility Statement" icon="accessibility_new" titleId="legal-accessibility-title"
      closeLabel="Close accessibility statement" (closed)="closePopup()"></app-modal-header>
    <div class="legal-content">
      <p class="legal-body">
        Complydome LLC is committed to ensuring digital accessibility for people with disabilities.
        We are continually improving the user experience for everyone and applying the relevant
        accessibility standards (WCAG 2.1 AA).
      </p>
      <h3 class="legal-section">Feedback</h3>
      <p class="legal-body">
        We welcome your feedback on the accessibility of Complydome. Please let us know if you
        encounter accessibility barriers:
      </p>
      <p class="legal-body">
        <strong>Email:</strong>
        <a href="mailto:support@complydome.com">support@complydome.com</a>
      </p>
      <p class="legal-body">We try to respond to accessibility feedback within 2 business days.</p>
    </div>
  </div>
</div>

<!-- Privacy Policy Popup -->
<div *ngIf="popup === 'privacy'" class="legal-overlay" (click)="closePopup()">
  <div class="legal-dialog" role="dialog" aria-modal="true" aria-labelledby="legal-privacy-title" (click)="$event.stopPropagation()">
    <app-modal-header title="Privacy Policy" icon="privacy_tip" titleId="legal-privacy-title"
      closeLabel="Close privacy policy" (closed)="closePopup()"></app-modal-header>
    <div class="legal-content">
      <p class="legal-body"><strong>Effective Date:</strong> April 17, 2025</p>
      <p class="legal-body">
        Complydome LLC ("we," "us," or "our") respects your privacy and is committed to protecting
        your personal data. This Privacy Policy explains how we collect, use, and safeguard your
        information when you access or use our website and services.
      </p>
      <h3 class="legal-section">1. Information We Collect</h3>
      <ul class="legal-list">
        <li><strong>Personal Data:</strong> Includes name, email, phone number, company, job title, and other identifiers you submit.</li>
        <li><strong>Usage Data:</strong> Includes browser type, IP address, pages visited, access times, device type, and similar analytics.</li>
        <li><strong>Cookies &amp; Tracking:</strong> We use cookies to enhance experience and analyze usage patterns. You may disable cookies via your browser.</li>
      </ul>
      <h3 class="legal-section">2. Use of Information</h3>
      <ul class="legal-list">
        <li>To provide and improve our services</li>
        <li>To personalize your experience</li>
        <li>To communicate with you, including sending updates, offers, or service notifications</li>
        <li>To ensure security and prevent fraud</li>
        <li>To comply with applicable laws and enforce legal rights</li>
      </ul>
      <h3 class="legal-section">3. How We Share Information</h3>
      <ul class="legal-list">
        <li>We <strong>do not sell</strong> or rent your personal data.</li>
        <li>We may share information with trusted service providers under confidentiality agreements.</li>
        <li>We may disclose data if required by law, court order, or to protect legal rights and safety.</li>
      </ul>
      <h3 class="legal-section">4. Data Security</h3>
      <p class="legal-body">
        We use technical, administrative, and physical safeguards to protect your information.
        All data is encrypted in transit and at rest using industry best practices.
      </p>
      <h3 class="legal-section">5. Your Rights</h3>
      <p class="legal-body">
        Depending on your location, you may have rights under data protection laws (e.g., GDPR, CCPA),
        including the right to access, correct, delete, or restrict your personal data. Contact us to
        exercise your rights at <a href="mailto:privacy@complydome.com">privacy@complydome.com</a>.
      </p>
      <h3 class="legal-section">6. Data Retention</h3>
      <p class="legal-body">
        We retain personal information only as long as necessary for legal, operational, or business
        purposes. When no longer required, data is securely deleted.
      </p>
      <h3 class="legal-section">7. Third-Party Services</h3>
      <p class="legal-body">
        Our platform may include links to external services or tools. We are not responsible for the
        privacy practices of third-party websites or providers.
      </p>
      <h3 class="legal-section">8. Children's Privacy</h3>
      <p class="legal-body">Our services are not directed to children under 13. We do not knowingly collect data from minors.</p>
      <h3 class="legal-section">9. International Transfers</h3>
      <p class="legal-body">
        If you are located outside the U.S., your data may be processed and stored in the United
        States or other jurisdictions with appropriate safeguards.
      </p>
      <h3 class="legal-section">10. Changes to This Policy</h3>
      <p class="legal-body">
        We may update this Privacy Policy. The latest version will always be available on our website.
        Continued use of our services constitutes acceptance of any changes.
      </p>
      <h3 class="legal-section">11. Contact Us</h3>
      <p class="legal-body">
        If you have questions about this Privacy Policy, contact us at
        <a href="mailto:privacy@complydome.com">privacy@complydome.com</a>.
      </p>
      <p class="legal-meta">&copy; {{ currentYear }} Complydome LLC. All rights reserved.</p>
    </div>
  </div>
</div>

<!-- Terms of Service Popup -->
<div *ngIf="popup === 'service'" class="legal-overlay" (click)="closePopup()">
  <div class="legal-dialog" role="dialog" aria-modal="true" aria-labelledby="legal-service-title" (click)="$event.stopPropagation()">
    <app-modal-header title="Terms of Service" icon="gavel" titleId="legal-service-title"
      closeLabel="Close terms of service" (closed)="closePopup()"></app-modal-header>
    <div class="legal-content">
    <p class="legal-body">
      Welcome to Complydome. By accessing or using our platform, you agree to be bound by the
      terms and conditions described herein.
    </p>
    <h3 class="legal-section">1. Acceptance of Terms</h3>
    <p class="legal-body">By using Complydome, you accept these terms in full. If you disagree with any part, you must not use the platform.</p>
    <h3 class="legal-section">2. Use of Services</h3>
    <p class="legal-body">You agree to use our services only for lawful purposes and in compliance with all applicable laws and regulations.</p>
    <h3 class="legal-section">3. User Responsibilities</h3>
    <p class="legal-body">You are responsible for safeguarding your account and ensuring your data input is accurate and lawful.</p>
    <h3 class="legal-section">4. Privacy &amp; Data</h3>
    <p class="legal-body">Use of the service is subject to our Privacy Policy. By using the platform, you consent to our use of your information as outlined.</p>
    <h3 class="legal-section">5. Modifications</h3>
    <p class="legal-body">We reserve the right to modify these terms at any time. Continued use after changes constitutes your acceptance.</p>
    <h3 class="legal-section">6. Termination</h3>
    <p class="legal-body">We may suspend or terminate your access to the platform for violations of these terms or any applicable laws.</p>
    <h3 class="legal-section">7. Limitation of Liability</h3>
    <p class="legal-body">Complydome is not liable for any indirect, incidental, or consequential damages resulting from your use of the service.</p>
    <h3 class="legal-section">8. Governing Law</h3>
    <p class="legal-body">These terms are governed by the laws of the state of Texas, without regard to conflict of law principles.</p>
    <p class="legal-body">If you have any questions, contact us at <a href="mailto:support@complydome.com">support@complydome.com</a>.</p>
    <p class="legal-meta">&copy; {{ currentYear }} Complydome LLC. All rights reserved.</p>
    </div>
  </div>
</div>
